var _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLists(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 155,
    viewBox: "0 0 228 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113,
    cy: 150.766,
    rx: 80,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2256,
    cy: 51.79,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1206,
    cy: 3.89502,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.899,
    cy: 125.895,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.9375,
    y1: 85.46,
    x2: 3.9375,
    y2: 91.46,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 88.71,
    x2: 1,
    y2: 88.71,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.187,
    y1: 27.21,
    x2: 209.188,
    y2: 33.21,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 212.25,
    y1: 30.46,
    x2: 206.25,
    y2: 30.46,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 149.953,
    y1: 10.8228,
    x2: 149.953,
    y2: 16.8228,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.016,
    y1: 14.0728,
    x2: 147.016,
    y2: 14.0728,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.048 40.9139C117.554 40.9139 117.964 40.5029 117.964 39.9958C117.964 39.4888 117.554 39.0778 117.048 39.0778C116.541 39.0778 116.131 39.4888 116.131 39.9958C116.131 40.5029 116.541 40.9139 117.048 40.9139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.527 40.9138C121.033 40.9138 121.444 40.5028 121.444 39.9957C121.444 39.4887 121.033 39.0776 120.527 39.0776C120.021 39.0776 119.61 39.4887 119.61 39.9957C119.61 40.5028 120.021 40.9138 120.527 40.9138Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.007 40.9139C124.513 40.9139 124.923 40.5029 124.923 39.9958C124.923 39.4888 124.513 39.0778 124.007 39.0778C123.5 39.0778 123.09 39.4888 123.09 39.9958C123.09 40.5029 123.5 40.9139 124.007 40.9139Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.102 28.2711H98.64C98.0104 28.2711 97.5 29.1299 97.5 30.1893V114.563C97.5 115.622 98.0104 116.481 98.64 116.481H178.102C178.732 116.481 179.242 115.622 179.242 114.563V30.1893C179.242 29.1299 178.732 28.2711 178.102 28.2711Z",
    fill: "#DDE4EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.102 28.3264H98.64C98.0104 28.3264 97.5 29.1621 97.5 30.193V35.613H179.242V30.193C179.242 29.1621 178.732 28.3264 178.102 28.3264Z",
    fill: "#8792A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.644 39.7362H102.537C101.93 39.7362 101.438 40.0339 101.438 40.4012V50.7282C101.438 51.0955 101.93 51.3932 102.537 51.3932H174.644C175.251 51.3932 175.743 51.0955 175.743 50.7282V40.4012C175.743 40.0339 175.251 39.7362 174.644 39.7362Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.644 54.8572H102.537C101.93 54.8572 101.438 55.1549 101.438 55.5221V65.8492C101.438 66.2165 101.93 66.5142 102.537 66.5142H174.644C175.251 66.5142 175.743 66.2165 175.743 65.8492V55.5221C175.743 55.1549 175.251 54.8572 174.644 54.8572Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.644 69.9781H102.537C101.93 69.9781 101.438 70.2759 101.438 70.6431V80.9702C101.438 81.3374 101.93 81.6351 102.537 81.6351H174.644C175.251 81.6351 175.743 81.3374 175.743 80.9702V70.6431C175.743 70.2759 175.251 69.9781 174.644 69.9781Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.644 85.0991H102.537C101.93 85.0991 101.438 85.3968 101.438 85.7641V96.0912C101.438 96.4584 101.93 96.7561 102.537 96.7561H174.644C175.251 96.7561 175.743 96.4584 175.743 96.0912V85.7641C175.743 85.3968 175.251 85.0991 174.644 85.0991Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.644 100.22H102.537C101.93 100.22 101.438 100.518 101.438 100.885V111.212C101.438 111.579 101.93 111.877 102.537 111.877H174.644C175.251 111.877 175.743 111.579 175.743 111.212V100.885C175.743 100.518 175.251 100.22 174.644 100.22Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.957 32.9114C106.477 32.9114 106.898 32.4897 106.898 31.9695C106.898 31.4493 106.477 31.0276 105.957 31.0276C105.438 31.0276 105.017 31.4493 105.017 31.9695C105.017 32.4897 105.438 32.9114 105.957 32.9114Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.527 32.9114C110.047 32.9114 110.468 32.4897 110.468 31.9695C110.468 31.4493 110.047 31.0276 109.527 31.0276C109.008 31.0276 108.587 31.4493 108.587 31.9695C108.587 32.4897 109.008 32.9114 109.527 32.9114Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.378 32.9114C102.898 32.9114 103.319 32.4897 103.319 31.9695C103.319 31.4493 102.898 31.0276 102.378 31.0276C101.859 31.0276 101.438 31.4493 101.438 31.9695C101.438 32.4897 101.859 32.9114 102.378 32.9114Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6873 58.4329C67.1936 58.4329 67.6041 58.0218 67.6041 57.5148C67.6041 57.0077 67.1936 56.5967 66.6873 56.5967C66.181 56.5967 65.7705 57.0077 65.7705 57.5148C65.7705 58.0218 66.181 58.4329 66.6873 58.4329Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1668 58.4329C70.6731 58.4329 71.0836 58.0218 71.0836 57.5148C71.0836 57.0077 70.6731 56.5967 70.1668 56.5967C69.6605 56.5967 69.25 57.0077 69.25 57.5148C69.25 58.0218 69.6605 58.4329 70.1668 58.4329Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6463 58.4329C74.1526 58.4329 74.5631 58.0218 74.5631 57.5148C74.5631 57.0077 74.1526 56.5967 73.6463 56.5967C73.14 56.5967 72.7295 57.0077 72.7295 57.5148C72.7295 58.0218 73.14 58.4329 73.6463 58.4329Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.742 45.79H48.2797C47.6501 45.79 47.1396 46.6488 47.1396 47.7082V132.082C47.1396 133.141 47.6501 134 48.2797 134H127.742C128.371 134 128.882 133.141 128.882 132.082V47.7082C128.882 46.6488 128.371 45.79 127.742 45.79Z",
    fill: "#DDE4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.742 45.8453H48.2797C47.6501 45.8453 47.1396 46.681 47.1396 47.7119V53.1319H128.882V47.7119C128.882 46.681 128.371 45.8453 127.742 45.8453Z",
    fill: "#8792A8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.283 57.2551H52.1763C51.5693 57.2551 51.0771 57.5528 51.0771 57.9201V68.2472C51.0771 68.6144 51.5693 68.9121 52.1763 68.9121H124.283C124.89 68.9121 125.382 68.6144 125.382 68.2472V57.9201C125.382 57.5528 124.89 57.2551 124.283 57.2551Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.283 72.3761H52.1763C51.5693 72.3761 51.0771 72.6738 51.0771 73.0411V83.3681C51.0771 83.7354 51.5693 84.0331 52.1763 84.0331H124.283C124.89 84.0331 125.382 83.7354 125.382 83.3681V73.0411C125.382 72.6738 124.89 72.3761 124.283 72.3761Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.283 87.4971H52.1763C51.5693 87.4971 51.0771 87.7948 51.0771 88.162V98.4891C51.0771 98.8563 51.5693 99.1541 52.1763 99.1541H124.283C124.89 99.1541 125.382 98.8563 125.382 98.4891V88.162C125.382 87.7948 124.89 87.4971 124.283 87.4971Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M124.283 102.618H52.1763C51.5693 102.618 51.0771 102.916 51.0771 103.283V113.61C51.0771 113.977 51.5693 114.275 52.1763 114.275H124.283C124.89 114.275 125.382 113.977 125.382 113.61V103.283C125.382 102.916 124.89 102.618 124.283 102.618Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.283 117.739H52.1763C51.5693 117.739 51.0771 118.037 51.0771 118.404V128.731C51.0771 129.098 51.5693 129.396 52.1763 129.396H124.283C124.89 129.396 125.382 129.098 125.382 128.731V118.404C125.382 118.037 124.89 117.739 124.283 117.739Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5968 50.4305C56.1163 50.4305 56.5374 50.0088 56.5374 49.4886C56.5374 48.9683 56.1163 48.5466 55.5968 48.5466C55.0774 48.5466 54.6562 48.9683 54.6562 49.4886C54.6562 50.0088 55.0774 50.4305 55.5968 50.4305Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1671 50.4305C59.6866 50.4305 60.1077 50.0088 60.1077 49.4886C60.1077 48.9683 59.6866 48.5466 59.1671 48.5466C58.6477 48.5466 58.2266 48.9683 58.2266 49.4886C58.2266 50.0088 58.6477 50.4305 59.1671 50.4305Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0177 50.4305C52.5372 50.4305 52.9583 50.0088 52.9583 49.4886C52.9583 48.9683 52.5372 48.5466 52.0177 48.5466C51.4983 48.5466 51.0771 48.9683 51.0771 49.4886C51.0771 50.0088 51.4983 50.4305 52.0177 50.4305Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.374,
    y: 38.9304,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0881 38.9304C48.7713 38.9304 46.5065 39.6174 44.5801 40.9046C42.6538 42.1918 41.1523 44.0213 40.2657 46.1617C39.3791 48.3022 39.1471 50.6575 39.5991 52.9298C40.0511 55.2022 41.1668 57.2894 42.805 58.9277C44.4433 60.5659 46.5305 61.6816 48.8028 62.1336C51.0751 62.5855 53.4305 62.3536 55.5709 61.467C57.7114 60.5803 59.5409 59.0789 60.8281 57.1525C62.1152 55.2262 62.8022 52.9614 62.8022 50.6445C62.7932 47.5405 61.5561 44.5663 59.3612 42.3714C57.1664 40.1766 54.1921 38.9395 51.0881 38.9304Z",
    fill: "#56D187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5165 44.6445H50.6593C50.3437 44.6445 50.0879 45.0027 50.0879 45.4445V55.8445C50.0879 56.2864 50.3437 56.6445 50.6593 56.6445H51.5165C51.8321 56.6445 52.0879 56.2864 52.0879 55.8445V45.4445C52.0879 45.0027 51.8321 44.6445 51.5165 44.6445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0879 51.0731V50.216C57.0879 49.9004 56.7413 49.6445 56.3137 49.6445H45.8621C45.4345 49.6445 45.0879 49.9004 45.0879 50.216V51.0731C45.0879 51.3887 45.4345 51.6445 45.8621 51.6445H56.3137C56.7413 51.6445 57.0879 51.3887 57.0879 51.0731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 150.766) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.374,
    y: 38.9304,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLists);
export default __webpack_public_path__ + "static/media/lists.ad2bce27b0325aeb65f89faaa02a6caa.svg";
export { ForwardRef as ReactComponent };